<div class="dev" *ngIf="demoModeEnabled">
    <textarea spellcheck="false">{{ state | json }} </textarea>
</div>
